import type { Store } from '../../../store/player/types';

export const handleMouseClickEvent = (store: Store): void => {
  const { clickSound, recording, isMuteClicksActive } = store.getState();

  if (!isMuteClicksActive && recording && recording.device === 'desktop') {
    const promise = clickSound.play();
    if (promise !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      promise.catch(() => {});
    }
  }
};
